<app-navbar></app-navbar>

<!-- Start Page Title Area -->
<div class="premium-page-header text-center" style="padding: 60px 0 30px;">
    <h1 class="ultimate-3d-title">যোগাযোগ</h1>
    <div class="premium-header-divider mx-auto mt-3"></div>
    <ul class="d-flex justify-content-center list-unstyled mt-3" style="gap: 10px; font-weight: 600;">
        <li><a routerLink="/" style="color: #0f4c3a; text-decoration: none;">হোম</a></li>
        <li style="color: #64748b;">/</li>
        <li style="color: #64748b;">যোগাযোগ</li>
    </ul>
</div>
<!-- End Page Title Area -->

<!-- Start Contact Area -->
<section class="contact-area" style="padding: 30px 0px 50px;">
    <div class="container">
        <div class="row justify-content-center g-4">
            <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="ultimate-3d-contact-card h-100 p-5 text-center">
                    <div class="icon-3d-wrapper mx-auto mb-4">
                        <i class="fa-solid fa-envelope"></i>
                    </div>
                    <h3 class="card-title fw-bold" style="color: #0f4c3a; font-size: 20px;">ইমেইল ঠিকানা</h3>
                    <p class="text-muted mt-3 mb-0" style="font-size: 16px;">
                        <a [href]="'mailto:' + (MainData?.Email || 'info@kmsc.edu.bd')"
                            style="color: inherit; text-decoration: none;">
                            {{ MainData?.Email || 'info@kmsc.edu.bd' }}
                        </a>
                    </p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="ultimate-3d-contact-card h-100 p-5 text-center">
                    <div class="icon-3d-wrapper mx-auto mb-4">
                        <i class="fa-solid fa-phone"></i>
                    </div>
                    <h3 class="card-title fw-bold" style="color: #0f4c3a; font-size: 20px;">ফোন নম্বর</h3>
                    <p class="text-muted mt-3 mb-0" style="font-size: 16px;">
                        <a [href]="'tel:' + (MainData?.ContactNo1 || MainData?.ContactNo || '+880 1712-345678')"
                            style="color: inherit; text-decoration: none;">
                            {{ MainData?.ContactNo1 || MainData?.ContactNo || '+880 1712-345678' }}
                        </a>
                    </p>
                </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-12">
                <div class="ultimate-3d-contact-card h-100 p-5 text-center">
                    <div class="icon-3d-wrapper mx-auto mb-4">
                        <i class="fa-solid fa-location-dot"></i>
                    </div>
                    <h3 class="card-title fw-bold" style="color: #0f4c3a; font-size: 20px;">ঠিকানা</h3>
                    <p class="text-muted mt-3 mb-0" style="font-size: 15px; line-height: 1.6;">
                        {{ MainData?.InstituteAddress || 'করতোয়া মাল্টিমিডিয়া স্কুল এন্ড কলেজ, বগুড়া, বাংলাদেশ' }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Contact Area -->

<div class="container pb-5">
    <div class="row">
        <div class="col-md-12">
            <div class="map-3d-wrapper p-2">
                <!-- <iframe 
                    [src]="safeMapUrl" 
                    width="100%" 
                    height="450" 
                    style="border:0; border-radius: 20px;" 
                    allowfullscreen="" 
                    loading="lazy" 
                    referrerpolicy="no-referrer-when-downgrade">
                </iframe> -->
            </div>
        </div>
    </div>
</div>